var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSocialTwitter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 22,
    viewBox: "0 0 27 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.6657 3.19453C25.6824 3.62231 24.6314 3.91119 23.5238 4.04453C24.654 3.37786 25.5242 2.3223 25.9311 1.06675C24.8744 1.68342 23.7046 2.13342 22.4558 2.3723C21.4556 1.3223 20.0315 0.666748 18.4606 0.666748C15.4373 0.666748 12.9905 3.07786 12.9905 6.05008C12.9905 6.47231 13.0357 6.88342 13.1318 7.27786C8.58276 7.05564 4.54801 4.91119 1.85252 1.65008C1.3835 2.44453 1.11225 3.3723 1.11225 4.35564C1.11225 6.22231 2.08421 7.87231 3.55345 8.83897C2.6493 8.81675 1.80167 8.57231 1.06705 8.16675C1.06705 8.18897 1.06705 8.2112 1.06705 8.23342C1.06705 10.8445 2.95445 13.0168 5.45781 13.5112C5.00008 13.6334 4.51411 13.7001 4.01682 13.7001C3.66647 13.7001 3.32176 13.6668 2.98836 13.6001C3.68342 15.739 5.70645 17.2945 8.10244 17.339C6.23198 18.7834 3.8699 19.6445 1.30438 19.6445C0.863614 19.6445 0.428493 19.6168 -0.000976562 19.5668C2.41196 21.1112 5.28828 22.0001 8.37368 22.0001C18.4493 22.0001 23.9533 13.7945 23.9533 6.67786C23.9533 6.44453 23.9476 6.21119 23.9363 5.98342C25.0043 5.22231 25.9311 4.27786 26.6657 3.19453Z",
    fill: "#014971"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSocialTwitter);
export default __webpack_public_path__ + "static/media/social-twitter.7489ea97df29aba0d0240ff6e5ae6bd0.svg";
export { ForwardRef as ReactComponent };